import React from 'react';
import { useTranslation } from 'react-i18next';

interface TechStackProps {
  technologies: Array<{
    name: string;
    icon: string;
    level: number;
    description?: string;
  }>;
}

const TechStack: React.FC<TechStackProps> = ({ technologies }) => {
  const { t } = useTranslation('skills');
  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6">
      {technologies.map((tech, index) => (
        <div
          key={tech.name}
          className="group relative p-6 rounded-2xl bg-dark-800/40 backdrop-blur-lg border border-dark-700 text-center transition-all duration-300 transform hover:-translate-y-2 hover:shadow-xl hover:shadow-primary-500/20 hover:border-primary-500/60"
        >
          {/* Icon */}
          <div
            className="text-4xl mb-3"
          >
            {tech.icon}
          </div>

          {/* Name */}
          <h3 className="font-semibold text-dark-200 mb-1 transition-colors duration-50">
            {tech.name}
          </h3>
          {tech.description && (
            <p className="text-xs text-dark-300 mb-2">
              {t(`descriptions.${tech.name}`, tech.description)}
            </p>
          )}



          {/* Hover Glow */}
          <div className="absolute inset-0 rounded-2xl bg-gradient-to-br from-primary-500/20 via-secondary-500/20 to-primary-500/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300 blur-lg -z-10" />

          {/* Corner Decorations */}



          {/* Glow Effect */}

        </div>
      ))}
    </div>
  );
};

export default TechStack;